import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { fetchPublicPromotions } from "api/auth";
import { PublicPromotion } from "interfaces/IPromotion";
import LoadingScreen from "components/general/LoadingScreen";
import "./AllPromotions.scss";
import CustomNavbarClients from "components/clients/components/navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import { useBreakpoints } from "hooks/useBreakPoints";
import { primaryColor } from "utils/colors";
import stars from "assets/estrellitas.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPercent, faTags } from "@fortawesome/free-solid-svg-icons";

const AllPromotions: React.FC = () => {
  const [promotions, setPromotions] = useState<PublicPromotion[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    const loadPromotions = async () => {
      try {
        const response = await fetchPublicPromotions();
        setPromotions(response);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching promotions:", error);
        setIsLoading(false);
      }
    };

    loadPromotions();
  }, []);

  if (isLoading) {
    return <LoadingScreen loadingText="Cargando promociones..." />;
  }

  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ margin: "1rem 0 0 0" }}
      >
        {!isMobile && (
          <div
            style={{
              height: "1px",
              background: primaryColor,
              flex: 1,
              maxWidth: "32%",
              boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
            }}
          />
        )}
        <h1
          style={{
            color: "black",
            fontWeight: "bold",
            fontSize: isMobile ? "28px" : "64px",
            letterSpacing: "3%",
            display: "flex",
            alignItems: "center",
            marginLeft: isMobile ? "1rem" : "4rem",
            textAlign: "center",
          }}
        >
          OFERTAS
        </h1>
        <img
          src={stars}
          alt="estrella"
          style={{
            width: isMobile ? "2rem" : "4rem",
            height: isMobile ? "2rem" : "4rem",
            verticalAlign: "middle",
            marginLeft: isMobile ? "0.5rem" : "0",
          }}
        />
        {!isMobile && (
          <div
            style={{
              height: "1px",
              background: primaryColor,
              flex: 1,
              maxWidth: "32%",
              boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
            }}
          />
        )}
      </div>
      <Container className="promotions-container">
        {promotions.length === 0 ? (
          <div className="empty-promotions">
            <h2
              style={{
                fontSize: isMobile ? "1.5rem" : "3rem",
                marginTop: "2rem",
                textAlign: "center",
                padding: isMobile ? "0 1rem" : "0",
              }}
            >
              Por el momento no hay promociones disponibles
            </h2>
            <h2
              style={{
                fontSize: isMobile ? "1.5rem" : "3rem",
                marginTop: "2rem",
                textAlign: "center",
                padding: isMobile ? "0 1rem" : "0",
              }}
            >
              ¡Vuelve pronto para futuras ofertas!
            </h2>
            <FontAwesomeIcon
              icon={faTags}
              className="promotion-icon mt-5"
              style={{ fontSize: isMobile ? "6rem" : "13rem" }}
            />
          </div>
        ) : (
          promotions.map((promotion, index) => (
            <div
              key={promotion.id}
              className={`promotion-card ${index % 2 === 0 ? "even" : "odd"}`}
            >
              <div className="promotion-image-container">
                <img
                  src={promotion.image}
                  alt={promotion.name}
                  className="promotion-image"
                />
              </div>
              <div className="promotion-content">
                <span className="promotion-title">{promotion.description}</span>
              </div>
            </div>
          ))
        )}
      </Container>
    </>
  );
};

export default AllPromotions;
